import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "hello",
    component: () => import("./views/Hello"),
  },


  /////// Short-URL

  {
    path: "/short-url/:urlHash",
    name: "short-url-home",
    component: () => import("./views/short_url/ShortUrlHome"),
  },

  /////// Nominate RECOMMEND

  {
    path: "/election/recommend/:hash",
    name: "recommend-home",
    component: () => import("./views/recommend/RecommendHome"),
  },
  {
    path: "/election/recommend/:hash/auth",
    name: "recommend-auth",
    component: () => import("./views/recommend/RecommendAuth"),
  },
  {
    path: "/election/recommend/:hash/vote",
    name: "recommend-vote",
    component: () => import("./views/recommend/RecommendVote"),
  },
  {
    path: "/election/recommend/:hash/complete",
    name: "recommend-complete",
    component: () => import("./views/recommend/RecommendComplete"),
  },
  {
    path: "/election/recommend/:hash/report",
    name: "recommend-report",
    component: () => import("./views/recommend/RecommendReport.vue"),
  },
  {
    path: "/election/recommend/:hash/submit",
    name: "recommend-submit",
    component: () => import("./views/recommend/RecommendSubmit.vue"),
  },


  ////// NOMINEE

  {
    path: "/election/nominee/:hash",
    name: "nominee-home",
    component: () => import("./views/nominee/NomineeHome"),
  },
  {
    path: "/election/nominee/:hash/auth",
    name: "nominee-auth",
    component: () => import("./views/nominee/NomineeAuth"),
  },
  {
    path: "/election/nominee/:hash/register",
    name: "nominee-register",
    component: () => import("./views/nominee/NomineeRegister"),
  },
  {
    path: "/election/nominee/:hash/complete",
    name: "nominee-complete",
    component: () => import("./views/nominee/NomineeComplete"),
  },

  ///////// Answer survey

  {
    path: "/answer/pages/:pageHash",
    name: "answer-home",
    component: () => import("./views/answer/AnswerHome"),
  },
  {
    path: "/answer/pages/:pageHash/auth",
    name: "answer-auth",
    component: () => import("./views/answer/AnswerAuth"),
  },
  {
    path: "/answer/pages/:pageHash/form",
    name: "answer-form",
    component: () => import("./views/answer/AnswerForm"),
  },
  {
    path: "/answer/pages/:pageHash/complete",
    name: "answer-complete",
    props: true,
    component: () => import("./views/answer/AnswerComplete"),
  },

];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});
export default router;